import { getChains, getTokenFee, getTokenTax } from './chain';
import {
  getConvertAmountRangeAll,
  getCryptocurrencyAmountRangeById,
  getCryptoCurrencyWithSymbol,
} from './cryptocurrency';
import {
  changeHistoryToReject,
  getHistoryById,
  getToChainHistories,
  postHistory,
} from './history';

const BridgeAPI = {
  postHistory,
  getToChainHistories,
  getHistoryById,
  getCryptocurrencyAmountRangeById,
  getConvertAmountRangeAll,
  getCryptoCurrencyWithSymbol,
  changeHistoryToReject,
  getTokenTax,
  getTokenFee,
  getChains,
};
export default BridgeAPI;
